import { Grid } from '@mui/material'
import { CustomInput, CustomTextArea } from 'src/consumer/components/helperComponents'
import { getRelatedClinicDetailsMdSize } from '../utils/prescriptionLayoutConfig'

/**
 * Component for related clinic details in multi-column footer layouts
 * Used for 2-column and 3-column footer layouts
 */
export default function RelatedClinicDetails({ clinicDetails, handleChange, idx, layoutType }) {
  const mdColNumber = getRelatedClinicDetailsMdSize(layoutType)

  return (
    <Grid item xs={12} md={mdColNumber} sx={{ marginTop: '12px' }}>
      <Grid container>
        <Grid item xs={12}>
          <h6>Column: {idx + 1}</h6>
        </Grid>
        <Grid item xs={12}>
          <CustomInput
            id="clinicName"
            value={clinicDetails?.clinicName || ''}
            label="Clinic Name"
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <CustomTextArea
            id="address"
            value={clinicDetails?.address || ''}
            label="Clinic Address"
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <CustomTextArea
            id="timings"
            value={clinicDetails?.timings || ''}
            label="Timings"
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <CustomTextArea
            id="timingsAltText"
            value={clinicDetails?.timingsAltText || ''}
            label="Timings Alt-Text"
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <CustomTextArea
            id="bottomText"
            value={clinicDetails?.bottomText || ''}
            label="Bottom Text"
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <CustomTextArea
            id="bottomText2"
            value={clinicDetails?.bottomText2 || ''}
            label="Bottom Text 2"
            onChange={handleChange}
          />
        </Grid>
      </Grid>
    </Grid>
  )
}
